import client from '@lib/services/client';

import { Currency2Dto as CurrencyDto, PlayerInfo } from '../_api';

export const getUser = (id: string, environment: string) => {
  return client.api.csPlayerControllerGetPlayer(id, { environment });
};

export const updateUser = (id: string, environment: string, data: PlayerInfo) => {
  return client.api.csPlayerControllerUpdateInfo(id, { environment }, data);
};

export const getCurrencies = (userId: string, environment: string) => {
  return client.api.csPlayerControllerGetCurrencies(userId, { environment });
};

export const removeCurrency = (userId: string, environment: string, currency: string) => {
  return client.api.csPlayerControllerRemoveCurrency(userId, { environment, currency });
};

export const updateCurrency = (userId: string, environment: string, currency: CurrencyDto) => {
  return client.api.csPlayerControllerUpdateCurrency(userId, { environment }, currency);
};

export const createCurrency = (userId: string, environment: string, currency: CurrencyDto) => {
  return client.api.csPlayerControllerAddCurrency(userId, { environment }, currency);
};

export const getBlueprintData = (
  userId: string,
  environment: string,
  type: string,
  variant?: string,
) => {
  return client.api.csPlayerControllerGetBlueprintData(userId, type, { environment, variant });
};
